/**
 * What a data-losing action would lose (src/ui/leaveGuard.ts). On the start path, so app.ts can run an action that loses
 * nothing at once, inside the tap; the guard's dialog is its own chunk, loaded only when there is something to lose
 * (docs/architecture.md "Size budget").
 */

/** What an action would lose. Empty = nothing: the action runs without asking. */
export interface Loss {
  payslips?: number;
  forms106?: number;
  /** Other files (not read, scans not read yet). */
  files?: number;
  typed?: boolean;
  answers?: boolean;
  /** One file by name (removing it). */
  file?: string;
}

export const losesSomething = (l: Loss): boolean =>
  (l.payslips ?? 0) > 0 || (l.forms106 ?? 0) > 0 || (l.files ?? 0) > 0 || Boolean(l.typed) || Boolean(l.answers) || Boolean(l.file);
